import {SET_NODES, SET_FROM_DATA} from '../actions/navbar';

const initialState = {
  nodes: [],
  from: {}
};

function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SET_NODES:
      return {...state, nodes: action.nodes};
    case SET_FROM_DATA:
      return {...state, from: action.from};
    default:
      return state;
  }
}

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/navbar.js